import UserTab from '@/components/TabSpr.vue'
import PeopleSelect from '@/views/people/PeoplePage.vue'
import http from '@/http-common'
import FormSelectVue from "@/components/resultTeam/FormSelectVue.vue";
import InputGroupForm from '@/components/InputGroupForm.vue'
import UserEditPage from '@/views/users/UserEditPage.vue'
import TabItemsUtils from "@/utils/tabItemsUtils";

export default {
  name: 'UsersList',
  components: {FormSelectVue, UserTab, PeopleSelect, InputGroupForm, UserEditPage},
  data() {
    return {
      captiontable: 'Пользователи',
      usersData: [],
      columns: [
        {key: 'username', label: 'Логин'},
        {key: 'peopleFio', label: 'Сотрудник'},
        {key: 'status', label: 'Статус'},
        {key: 'edit_field', label: ''}
      ],
      urls: {
        save: '/users/save',
        delete: '/users/delete',
      },
      selectedUser: {
        id: null,
        username: '',
        email_address: '',
        password: null
      },
      modalEditOpened: false,
      changePswDiv: false,
      changeRoleDiv: false,
      changePermissionDiv: false,
      captionUser: {
        name: 'Пользователь',
        nameR: 'пользователя'
      },
      peopleList: [],
      roles: [],
      statusList: [],
      selectedPerm: [],
    }
  },
  created() {
    this.loadUsers();
    this.loadRoles();
    this.loadStatus();
    this.loadPeoples()
  },
  methods: {
    checkForm() {
      for (var key in this.validValue) {
        this.validValue[key] = true;
      }
      if (!this.selectedUser.username || this.selectedUser.username === '') {
        this.validValue.username = false;
        this.validValue.form = false;
      }
    },
    loadStatus() {
      var vm = this;
      http.get('/users/statuslist')
      .then((response) => {
        vm.statusList = response.data;
      })
      .catch((error) => console.log(error.message));
    },
    loadPeoples() {
      var vm = this;
      http.get('/people/options')
      .then((response) => {
        vm.peopleList = response.data;
      })
      .catch((error) => console.log(error.message));
    },
    loadRoles() {
      var vm = this;
      http.get('/roles')
      .then((response) => {
        vm.roles = response.data;
        vm.roles.forEach(function (x) {
          x.value = x.name;
          x.text = x.description ? x.description : x.name
        })
      })
      .catch((error) => console.log(error.message));
    },
//      loadPermissions() {
//        var vm = this;
//          var token = localStorage.getItem('token');
//        axios.get('/permissions', {headers: { Authorization: 'Bearer_' + token }})
//          .then((response) => {
//            vm.permissions = response.data;
//          })
//          .catch((error) => console.log(error.response.data));
//      },

    loadUsers() {
      var vm = this;
      http.get('/users')
      .then((response) => {
        vm.usersData = response.data;
      })
      .catch((error) => console.log(error.response.data));
    },
    showEditDialog() {
      this.$refs.UserEditRef.showEditForm(this.selectedUser.id)
//       this.loadRoles();
//       this.loadStatus();
//       this.loadPeoples();
//       this.insertPass1 = '';
//       this.insertPass2 = '';
//       if (this.selectedUser.id == null) {
//         this.changePswDiv = true;
//       } else {
//         this.changePswDiv = false;
//       }
//       if (this.selectedUser.roles == null) {
//         this.selectedUser.roles = [];
//       }
//       this.selectedRole = this.selectedUser.roles;
//       //this.selectedPerm = this.selectedUser.permissions;
//       this.modalEditOpened = !this.modalEditOpened;
// //        this.$bvModal.show("editModal");
    },
    saveItem(data, addFlag) {
      TabItemsUtils.updateTableRow(this.usersData, data, addFlag)
    },
    // saveUser() {
    //   this.checkForm();
    //   if (this.validValue.form && this.validPass) {
    //     //this.modalEditOpened = false;
    //     if (this.insertPass2.length > 0) {
    //       this.selectedUser.password = this.insertPass2;
    //     } else {
    //       this.selectedUser.password = null;
    //     }
    //     this.selectedUser.roles = this.selectedRole;
    //     //this.selectedUser.permissions = this.selectedPerm;
    //     this.$refs.UserTab.save(this.selectedUser);
    //   }
    // },
    // selectPeople() {
    //   this.selectedUser.peopleFio = this.selectedPeople.fio;
    //   this.selectedUser.peopleId = this.selectedPeople.id;
    //   this.modalPeopleOpened = false;
    // },
    showPeopleDialog() {
      this.modalPeopleOpened = !this.modalPeopleOpened;
    },
    closeEditDialog() {
      this.modalEditOpened = false;
    }
  }
}
